<template>
  <section class="itinerary-staff-pick-events-section">
    <h2 class="itinerary-staff-pick-events-section__header">Not to miss</h2>
    <ItineraryStaffPickEvents :events="events" />
  </section>
</template>

<script>
import ItineraryStaffPickEvents from '@/components/itinerary/ItineraryStaffPickEvents.vue';

export default {
  components: { ItineraryStaffPickEvents },
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.itinerary-staff-pick-events-section {
  &__header {
    margin-bottom: 32px;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 3px;
    text-transform: uppercase;
    text-align: center;

    @media (min-width: vars.$mobile-break-point + 1px) {
      margin-bottom: 40px;
    }
  }
}
</style>
